// extracted by mini-css-extract-plugin
export default {"release-timing-notice":"form_release-timing-notice__NRrlx","release-timing-notice__primary-value":"form_release-timing-notice__primary-value__Rk-Ys"};